import React, { useEffect, useState } from "react";
import { CountryDropdown } from "react-country-region-selector";
import dayjs from "dayjs";
import { Button, Input, Select, DatePicker, Upload, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import useImageUpload from "../../../../hooks/useImageUpload";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Option } from "antd/es/mentions";
import moment from "moment";

function Ships({ id, onSuccess }) {
  const navigate = useNavigate();
  const [access_ip, set_access_ip] = useState("");
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      set_errors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };
  const [ship_class, set_ship_class] = useState(" ");
  const [other_ship_class, set_other_ship_class] = useState("");
  const [shipClasses, setShipClasses] = useState([
    "IRS",
    "ABS",
    "KR",
    "DNV",
    "CCS",
    "NKK",
    "VNV",
    "LR",
    "Others",
  ]);
  const [ship_type, set_ship_type] = useState(" ");
  const [other_ship_type, set_other_ship_type] = useState("");
  const [shiptypes, setshiptypes] = useState([
    "Oil Tanker",
    "Chemical Tanker",
    "Oil/Chem Tanker",
    "LPG",
    "LNG",
    "Bulk Carrier",
    "General Cargo",
    "Container",
    "Ro-Ro",
    "Others",
  ]);
  const [vessel_name, set_vessel_name] = useState("");
  const [imo_number, set_imo_number] = useState("");
  const [flag, set_flag] = useState("");
  const [deadweight, set_deadweight] = useState("");
  // const [grt, set_grt] = useState("");
  const [maximum_draft, set_maximum_draft] = useState("");
  const [email_address, set_email_address] = useState("");
  const [length_overall, set_length_overall] = useState("");
  const [date_of_delivery, set_date_of_delivery] = useState(null);
  const [call_sign, set_call_sign] = useState("");
  const [telephone, set_telephone] = useState("");
  const [sat_c, set_sat_c] = useState("");
  const [length_between_perpendiculars, set_length_between_perpendiculars] = useState("");
  const [moulded_depth, set_moulded_depth] = useState("");
  const [keel_to_masthead, set_keel_to_masthead] = useState("");
  const [bow_to_center_manifold, set_bow_to_center_manifold] = useState("");
  const [distance_bridge_manifold, set_distance_bridge_manifold] = useState("");
  const [forward_manifold, set_forward_manifold] = useState("");
  const [aft_manifold, set_aft_manifold] = useState("");
  const [parallel_body_distance, set_parallel_body_distance] = useState("");
  const [tpc_at_summer_draft, set_tpc_at_summer_draft] = useState("");
  const [constant_weight, set_constant_weight] = useState("");
  const [max_height_above_waterline, set_max_height_above_waterline] = useState("");
  const [full_mast, set_full_mast] = useState(0);
  const [lightship, set_lightship] = useState("");
  const [normal_ballast, set_normal_ballast] = useState("");
  const [loaded_summer_deadweight, set_loaded_summer_deadweight] = useState("");
  const [gross_tonnage, set_gross_tonnage] = useState("");
  const [suez_canal_tonnage, set_suez_canal_tonnage] = useState("");
  const [panama_canal_tonnage, set_panama_canal_tonnage] = useState("");
  const [net_tonnage, set_net_tonnage] = useState("");
  const [extreme_breadth, set_extreme_breadth] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [initialPhotos, setInitialPhotos] = useState([]);
  const [port_registry, set_Port_Registry] = useState("");
  const [mmsi_number, set_MMSI_Number] = useState("");
  const [official_number, set_Official_Number] = useState("");
  const [year_built, set_Year_Built] = useState("");
  const [pitch, set_pitch] = useState("");
  const { fileList, setFileList, processFilesToBase64 } = useImageUpload(initialPhotos);

  const ADD_API = async () => {
    set_loader(true);
    const base64Image = await processFilesToBase64();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (vessel_name && /^\d+$/.test(vessel_name)) {
      set_errors((prev) => ({
        ...prev,
        vessel_name: "Vessel name cannot be purely numeric.",
      }));
      set_loader(false);
      return;
    }
    if (email_address && !emailRegex.test(email_address)) {
      set_errors((prev) => ({
        ...prev,
        email_address: "Please enter a valid email address.",
      }));
      set_loader(false);
      return;
    }
    if (telephone && (telephone.length < 8 || telephone.length > 15)) {
      set_errors((prev) => ({
        ...prev,
        telephone: "Telephone number must be between 8 and 15 digits.",
      }));
      set_loader(false);
      return;
    }
    try {
      const FORM_DATA = new FormData();
      const appendIfValid = (key, value) => {
        if (value !== null && value !== undefined && value !== "" && value !== "null") {
          FORM_DATA.append(key, value);
        }
      };

      const user_Data = JSON.parse(localStorage.getItem("user_data"));
      FORM_DATA.append("photos", JSON.stringify(base64Image));
      appendIfValid("comapny_id", user_Data?.data?.company?.company_id);
      appendIfValid("user_id", user_Data?.data?.user_id);
      FORM_DATA.append(
        "date_of_delivery",
        date_of_delivery || moment(new Date()).format("YYYY-MM-DD")
      );
      // FORM_DATA.append("grt", grt);
      appendIfValid("maximum_draft", maximum_draft);
      appendIfValid("deadweight", deadweight);
      appendIfValid("call_sign", call_sign);
      appendIfValid("telephone", telephone);
      appendIfValid("email_address", email_address);
      appendIfValid("full_mast", full_mast);
      appendIfValid("extreme_breadth", extreme_breadth);
      appendIfValid("lightship", lightship);
      appendIfValid("sat_c", sat_c);
      appendIfValid("length_between_perpendiculars", length_between_perpendiculars);
      appendIfValid("moulded_depth", moulded_depth);
      appendIfValid("keel_to_masthead", keel_to_masthead);
      appendIfValid("bow_to_center_manifold", bow_to_center_manifold);
      appendIfValid("distance_bridge_manifold", distance_bridge_manifold);
      appendIfValid("forward_manifold", forward_manifold);
      appendIfValid("aft_manifold", aft_manifold);
      appendIfValid("parallel_body_distance", parallel_body_distance);
      appendIfValid("tpc_at_summer_draft", tpc_at_summer_draft);
      appendIfValid("constant_weight", constant_weight);
      appendIfValid("max_height_above_waterline", max_height_above_waterline);
      appendIfValid("length_overall", length_overall);
      appendIfValid("normal_ballast", normal_ballast);
      appendIfValid("loaded_summer_deadweight", loaded_summer_deadweight);
      appendIfValid("suez_canal_tonnage", suez_canal_tonnage);
      appendIfValid("panama_canal_tonnage", panama_canal_tonnage);
      appendIfValid("net_tonnage", net_tonnage);
      appendIfValid("gross_tonnage", gross_tonnage);
      appendIfValid("access_ip", access_ip);
      appendIfValid("vessel_name", vessel_name);
      appendIfValid("imo_number", imo_number);
      appendIfValid("flag", flag);
      appendIfValid("ship_class", ship_class);
      appendIfValid("other_ship_class", other_ship_class);
      appendIfValid("ship_type", ship_type);
      appendIfValid("other_ship_type", other_ship_type);
      appendIfValid("mmsi_number", mmsi_number);
      appendIfValid("official_number", official_number);
      appendIfValid("year_built", year_built);
      appendIfValid("port_of_registry", port_registry);
      appendIfValid("pitch", pitch);

      post(ApiURL.add_ship, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          SuccessToast("Congratulation!!", "Ships Basic Details Successfully Added!!");
          // Sync localStorage if this is the user's assigned ship
          const localUser = JSON.parse(localStorage.getItem("user_data"));
          if (localUser?.data?.ship_details?.id == res?.ship_data?.ship_id && localUser?.data) {
            localUser.data.ship_details = res.ship_data;
            localStorage.setItem("user_data", JSON.stringify(localUser));
          }
          localStorage.setItem("selectedTab", "main");
          navigate("/edit-ship/" + btoa(res?.ship_data?.ship_id));
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      console.error("Registration error: ", error);
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const UPDATE_API = async () => {
    set_loader(true);
    const base64Image = await processFilesToBase64();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (vessel_name && /^\d+$/.test(vessel_name)) {
      set_errors((prev) => ({
        ...prev,
        vessel_name: "Vessel name cannot be purely numeric.",
      }));
      set_loader(false);
      return;
    }
    if (email_address && !emailRegex.test(email_address)) {
      set_errors((prev) => ({
        ...prev,
        email_address: "Please enter a valid email address.",
      }));
      set_loader(false);
      return;
    }
    if (telephone && (telephone.length < 8 || telephone.length > 15)) {
      set_errors((prev) => ({
        ...prev,
        telephone: "Telephone number must be between 8 and 15 digits.",
      }));
      set_loader(false);
      return;
    }
    try {
      const FORM_DATA = new FormData();
      const appendIfValid = (key, value) => {
        if (value !== null && value !== undefined && value !== "" && value !== "null") {
          FORM_DATA.append(key, value);
        }
      };

      FORM_DATA.append("photos", JSON.stringify(base64Image));
      FORM_DATA.append(
        "date_of_delivery",
        date_of_delivery || moment(new Date()).format("YYYY-MM-DD")
      );
      // FORM_DATA.append("grt", grt);
      appendIfValid("maximum_draft", maximum_draft);
      appendIfValid("deadweight", deadweight);
      appendIfValid("call_sign", call_sign);
      appendIfValid("telephone", telephone);
      appendIfValid("email_address", email_address);
      appendIfValid("full_mast", full_mast);
      appendIfValid("extreme_breadth", extreme_breadth);
      appendIfValid("lightship", lightship);
      appendIfValid("sat_c", sat_c);
      appendIfValid("length_between_perpendiculars", length_between_perpendiculars);
      appendIfValid("moulded_depth", moulded_depth);
      appendIfValid("keel_to_masthead", keel_to_masthead);
      appendIfValid("bow_to_center_manifold", bow_to_center_manifold);
      appendIfValid("distance_bridge_manifold", distance_bridge_manifold);
      appendIfValid("forward_manifold", forward_manifold);
      appendIfValid("aft_manifold", aft_manifold);
      appendIfValid("parallel_body_distance", parallel_body_distance);
      appendIfValid("tpc_at_summer_draft", tpc_at_summer_draft);
      appendIfValid("constant_weight", constant_weight);
      appendIfValid("max_height_above_waterline", max_height_above_waterline);
      appendIfValid("length_overall", length_overall);
      appendIfValid("normal_ballast", normal_ballast);
      appendIfValid("loaded_summer_deadweight", loaded_summer_deadweight);
      appendIfValid("suez_canal_tonnage", suez_canal_tonnage);
      appendIfValid("panama_canal_tonnage", panama_canal_tonnage);
      appendIfValid("net_tonnage", net_tonnage);
      appendIfValid("gross_tonnage", gross_tonnage);
      appendIfValid("access_ip", access_ip);
      appendIfValid("vessel_name", vessel_name);
      appendIfValid("imo_number", imo_number);
      appendIfValid("flag", flag);
      appendIfValid("ship_class", ship_class);
      appendIfValid("other_ship_class", other_ship_class);
      appendIfValid("ship_type", ship_type);
      appendIfValid("other_ship_type", other_ship_type);
      appendIfValid("id", atob(id));
      appendIfValid("mmsi_number", mmsi_number);
      appendIfValid("official_number", official_number);
      appendIfValid("year_built", year_built);
      appendIfValid("port_of_registry", port_registry);
      appendIfValid("pitch", pitch);

      post(ApiURL.edit_ship_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Basic Details Saved!", "Basic Details Sucessfully Updated!!");
          set_loader(false);
          if (onSuccess) onSuccess();
          // Sync localStorage if this is the user's assigned ship
          const localUser = JSON.parse(localStorage.getItem("user_data"));
          if (localUser?.data?.ship_details?.id == res?.ship_data?.ship_id && localUser?.data) {
            localUser.data.ship_details = res.ship_data;
            localStorage.setItem("user_data", JSON.stringify(localUser));
          }
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  const VIEW_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      post(ApiURL.view_ship_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const Ship_Data = res?.ship_data;
          set_access_ip(Ship_Data?.access_ip);
          set_ship_class(Ship_Data?.ship_class);
          set_other_ship_class(Ship_Data?.other_ship_class);
          set_ship_type(Ship_Data?.ship_type);
          set_other_ship_type(Ship_Data?.other_ship_type);
          set_vessel_name(Ship_Data?.vessel_name);
          set_imo_number(Ship_Data?.imo_number);
          set_flag(Ship_Data?.flag);
          set_deadweight(Ship_Data?.deadweight);
          // set_grt(Ship_Data?.grt);
          set_maximum_draft(Ship_Data?.maximum_draft);
          set_email_address(Ship_Data?.email_address);
          set_length_overall(Ship_Data?.length_overall);
          set_sat_c(Ship_Data?.sat_c);
          set_length_between_perpendiculars(Ship_Data?.length_between_perpendiculars);
          set_moulded_depth(Ship_Data?.moulded_depth);
          set_keel_to_masthead(Ship_Data?.keel_to_masthead);
          set_bow_to_center_manifold(Ship_Data?.bow_to_center_manifold);
          set_distance_bridge_manifold(Ship_Data?.distance_bridge_manifold);
          set_forward_manifold(Ship_Data?.forward_manifold);
          set_aft_manifold(Ship_Data?.aft_manifold);
          set_parallel_body_distance(Ship_Data?.parallel_body_distance);
          set_tpc_at_summer_draft(Ship_Data?.tpc_at_summer_draft);
          set_constant_weight(Ship_Data?.constant_weight);
          set_max_height_above_waterline(Ship_Data?.max_height_above_waterline);
          set_full_mast(Ship_Data?.full_mast ? 1 : 0);
          set_lightship(Ship_Data?.lightship);
          set_normal_ballast(Ship_Data?.normal_ballast);
          set_loaded_summer_deadweight(Ship_Data?.loaded_summer_deadweight);
          set_gross_tonnage(Ship_Data?.gross_tonnage);
          set_suez_canal_tonnage(Ship_Data?.suez_canal_tonnage);
          set_panama_canal_tonnage(Ship_Data?.panama_canal_tonnage);
          set_net_tonnage(Ship_Data?.net_tonnage);
          set_telephone(Ship_Data?.telephone);
          set_date_of_delivery(Ship_Data?.date_of_delivery);
          set_call_sign(Ship_Data?.call_sign);
          set_extreme_breadth(Ship_Data?.extreme_breadth);
          set_Port_Registry(Ship_Data?.port_of_registry);
          set_MMSI_Number(Ship_Data?.mmsi_number);
          set_Official_Number(Ship_Data?.official_number);
          set_Year_Built(Ship_Data?.year_built);
          setInitialPhotos(Ship_Data?.image_ship ? Ship_Data?.image_ship : []);
          set_pitch(Ship_Data?.pitch);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    if (id) {
      VIEW_API();
    }
  }, []);

  const handleDateChange = (date, dateString) => {
    const formattedDate = dateString;
    set_date_of_delivery(formattedDate);
    clearError("date_of_delivery");
  };

  const handleYearBuiltChange = (date, dateString) => {
    const formattedDate = dateString;

    set_Year_Built(formattedDate);
    clearError("year_built");
  };

  const handleShipClassChange = (value) => {
    set_ship_class(value);
    clearError("ship_class");
    if (value !== "Others") {
      set_other_ship_class("");
    }
  };

  const handleOtherShipClassChange = (e) => {
    set_other_ship_class(e.target.value);
    clearError("ship_class");
  };

  // ship type
  const handleShipTypeChange = (value) => {
    set_ship_type(value);
    clearError("ship_type");
    if (value !== "Others") {
      set_other_ship_type("");
    }
  };

  const handleOtherShipTypeChange = (e) => {
    set_other_ship_type(e.target.value);
    clearError("ship_type");
  };

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setPreviewImage(src);
    setPreviewTitle(file.name);
    setPreviewVisible(true);
  };

  const handleChange = (info) => {
    if (info.fileList?.length > 1) {
      ErrorToast("Image Upload Message", "Sorry, only a single image can be uploaded.");
      return;
    }
    setFileList(info.fileList);
    clearError("image_ship");
  };
  const handleSelectChange = (value) => {
    set_full_mast(value); // Convert value to a number
    clearError("full_mast");
  };

  return (
    <>
      <h3 style={{ marginTop: "15px" }}>Ship Basic Information </h3>
      <div className="row">
        <div
          style={{
            background: "#fff",
          }}
          className="col-12"
        >
          <div className="col-12">
           
            <div className="input-box">
              <label>Select Ship Photo</label>
              <Upload
                accept="image/*"
                fileList={fileList}
                onChange={handleChange}
                onPreview={handlePreview}
                beforeUpload={() => false}
                listType="picture-circle"
              >
                {fileList.length === 0 && (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                )}
              </Upload>
            </div>
            {errors?.image_ship && (
              <>
                <span style={{ color: "red" }}>{errors?.image_ship}</span>
              </>
            )}
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Vessel Name<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={vessel_name}
                  placeholder="vessel name"
                  onChange={(e) => {
                    set_vessel_name(e.target.value);
                    clearError("vessel_name");
                  }}
                />
                {errors?.vessel_name && (
                  <>
                    <span style={{ color: "red" }}>{errors?.vessel_name}</span>
                  </>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>
                  IMO NUMBER<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={imo_number}
                  maxLength={7}
                  placeholder="Imo number"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 7) {
                      set_imo_number(value);
                      clearError("imo_number");
                    }
                  }}
                />
                {errors?.imo_number && (
                  <>
                    <span style={{ color: "red" }}>{errors?.imo_number}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label>Date</label>
              <DatePicker
                style={{ width: "100%" }}
                value={date_of_delivery ? dayjs(date_of_delivery) : ""}
                onChange={handleDateChange}
              />
              {errors?.date_of_delivery && (
                <span style={{ color: "red" }}>{errors?.date_of_delivery}</span>
              )}
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>
                  Port Of Registry<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={port_registry}
                  placeholder="Port Of Registry"
                  onChange={(e) => {
                    set_Port_Registry(e.target.value);
                    clearError("port_of_registry");
                  }}
                />
                {errors?.port_of_registry && (
                  <>
                    <span style={{ color: "red" }}>{errors?.port_of_registry}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Ship Class<span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className={ship_class === "Others" ? "col-8" : "col-12"}>
                    <Select
                      style={{ width: "100%" }}
                      value={ship_class}
                      onChange={handleShipClassChange}
                    >
                      <Select.Option key={"Select-Ship-Class"} value=" ">
                        Select Ship Class
                      </Select.Option>

                      {shipClasses.map((shipClass) => (
                        <Select.Option key={shipClass} value={shipClass}>
                          {shipClass}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  {ship_class === "Others" && (
                    <>
                      <div className="col-4">
                        <Input
                          placeholder="Enter New Ship Class"
                          value={other_ship_class}
                          onChange={handleOtherShipClassChange}
                        />
                      </div>
                    </>
                  )}
                </div>
                {errors?.ship_class && <span style={{ color: "red" }}>{errors?.ship_class}</span>}
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>
                  Deadweight<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={deadweight}
                  placeholder="--- deadweight ----"
                  onChange={(e) => {
                    set_deadweight(e.target.value);
                    clearError("deadweight");
                  }}
                />
                {errors?.deadweight && (
                  <>
                    <span style={{ color: "red" }}>{errors?.deadweight}</span>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            {/* ship type*/}
            <div className="col-6">
              <div className="input-box">
                <label>
                  Ship Type<span style={{ color: "red" }}>*</span>
                </label>
                <div className="row">
                  <div className={ship_type === "Others" ? "col-8" : "col-12"}>
                    <Select
                      style={{ width: "100%" }}
                      value={ship_type}
                      onChange={handleShipTypeChange}
                    >
                      <Select.Option key={"Select-Ship-type"} value=" ">
                        Select Ship Type
                      </Select.Option>

                      {shiptypes.map((shipType) => (
                        <Select.Option key={shipType} value={shipType}>
                          {shipType}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                  {ship_type === "Others" && (
                    <>
                      <div className="col-4">
                        <Input
                          placeholder="Enter New Ship Type"
                          value={other_ship_type}
                          onChange={handleOtherShipTypeChange}
                        />
                      </div>
                    </>
                  )}
                </div>
                {errors?.ship_type && <span style={{ color: "red" }}>{errors?.ship_type}</span>}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>
                  Flag state<span style={{ color: "red" }}>*</span>
                </label>
                <CountryDropdown
                  style={{ width: "100%", height: "32px" }}
                  value={flag}
                  onChange={(value) => {
                    set_flag(value);
                    clearError("flag");
                  }}
                  className="ant-input css-dev-only-do-not-override-djtmh8 ant-input-outlined"
                />
                {errors?.flag && <span style={{ color: "red" }}>{errors?.flag}</span>}
              </div>
            </div>
          </div>
          <div className="row">
           
            {/* Maximum Draft */}
            <div className="col-6">
              <div className="input-box">
                <label>
                  Maximum Draft<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={maximum_draft}
                  placeholder="Value of draft"
                  onChange={(e) => {
                    set_maximum_draft(e.target.value);
                    clearError("maximum_draft");
                  }}
                />
                {errors?.maximum_draft && (
                  <>
                    <span style={{ color: "red" }}>{errors?.maximum_draft}</span>
                  </>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>
                  MMSI Number<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={mmsi_number}
                  placeholder="MMSI Number"
                  onChange={(e) => {
                    set_MMSI_Number(e.target.value);
                    clearError("mmsi_number");
                  }}
                />
                {errors?.mmsi_number && (
                  <>
                    <span style={{ color: "red" }}>{errors?.mmsi_number}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Official Number<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  type="number"
                  value={official_number}
                  placeholder="Official Number"
                  onChange={(e) => {
                    set_Official_Number(e.target.value);
                    clearError("official_number");
                  }}
                />
                {errors?.official_number && (
                  <span style={{ color: "red" }}>{errors?.official_number}</span>
                )}
              </div>
            </div>

            <div className="col-6">
              <label>
                Year Built<span style={{ color: "red" }}>*</span>
              </label>
              <DatePicker
                style={{ width: "100%" }}
                value={year_built ? dayjs(year_built) : ""}
                onChange={handleYearBuiltChange}
              />
              {errors?.year_built && <span style={{ color: "red" }}>{errors?.year_built}</span>}
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Email Address<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={email_address}
                  placeholder="Email Address"
                  onChange={(e) => {
                    set_email_address(e.target.value);
                    clearError("email_address");
                  }}
                />
                {errors?.email_address && (
                  <span style={{ color: "red" }}>{errors?.email_address}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>
                  Length overall<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={length_overall}
                  placeholder="Length overall"
                  onChange={(e) => {
                    set_length_overall(e.target.value);
                    clearError("length_overall");
                  }}
                />
                {errors?.length_overall && (
                  <span style={{ color: "red" }}>{errors?.length_overall}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  SAT-C<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={sat_c}
                  placeholder="Sat-C"
                  onChange={(e) => {
                    set_sat_c(e.target.value);
                    clearError("sat_c");
                  }}
                />
                {errors?.sat_c && <span style={{ color: "red" }}>{errors?.sat_c}</span>}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Length Between Perpendiculars</label>
                <Input
                  value={length_between_perpendiculars}
                  placeholder="Length Between Perpendiculars"
                  onChange={(e) => {
                    set_length_between_perpendiculars(e.target.value);
                    clearError("length_between_perpendiculars");
                  }}
                />
                {errors?.length_between_perpendiculars && (
                  <span style={{ color: "red" }}>{errors?.length_between_perpendiculars}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Moulded Depth</label>
                <Input
                  value={moulded_depth}
                  placeholder="Moulded Depth"
                  onChange={(e) => {
                    set_moulded_depth(e.target.value);
                    clearError("moulded_depth");
                  }}
                />
                {errors?.moulded_depth && (
                  <span style={{ color: "red" }}>{errors?.moulded_depth}</span>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Distance Keel to Masthead</label>
                <Input
                  value={keel_to_masthead}
                  placeholder="Distance Keel to Masthead"
                  onChange={(e) => {
                    set_keel_to_masthead(e.target.value);
                    clearError("keel_to_masthead");
                  }}
                />
                {errors?.keel_to_masthead && (
                  <span style={{ color: "red" }}>{errors?.keel_to_masthead}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Distance Bow to Center Manifold</label>
                <Input
                  value={bow_to_center_manifold}
                  placeholder="Distance Bow to Center Manifold"
                  onChange={(e) => {
                    set_bow_to_center_manifold(e.target.value);
                    clearError("bow_to_center_manifold");
                  }}
                />
                {errors?.bow_to_center_manifold && (
                  <span style={{ color: "red" }}>{errors?.bow_to_center_manifold}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Distance Bridge Manifold</label>
                <Input
                  value={distance_bridge_manifold}
                  placeholder="Distance Bridge Manifold"
                  onChange={(e) => {
                    set_distance_bridge_manifold(e.target.value);
                    clearError("distance_bridge_manifold");
                  }}
                />
                {errors?.distance_bridge_manifold && (
                  <span style={{ color: "red" }}>{errors?.distance_bridge_manifold}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Distance FWD to Mid Point Manifold</label>
                <Input
                  value={forward_manifold}
                  placeholder="Distance FWD to Mid Point Manifold"
                  onChange={(e) => {
                    set_forward_manifold(e.target.value);
                    clearError("forward_manifold");
                  }}
                />
                {errors?.forward_manifold && (
                  <span style={{ color: "red" }}>{errors?.forward_manifold}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Distance Aft to Mid Point Manifold</label>
                <Input
                  value={aft_manifold}
                  placeholder="Distance Aft to midpoint Manifold"
                  onChange={(e) => {
                    set_aft_manifold(e.target.value);
                    clearError("aft_manifold");
                  }}
                />
                {errors?.aft_manifold && (
                  <span style={{ color: "red" }}>{errors?.aft_manifold}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>TPC At Summer Draft</label>
                <Input
                  value={tpc_at_summer_draft}
                  placeholder="TPC at Summer draft"
                  onChange={(e) => {
                    set_tpc_at_summer_draft(e.target.value);
                    clearError("tpc_at_summer_draft");
                  }}
                />
                {errors?.tpc_at_summer_draft && (
                  <span style={{ color: "red" }}>{errors?.tpc_at_summer_draft}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Distances Prallel Body </label>
                <Input
                  value={parallel_body_distance}
                  placeholder="Distances Prallel Body "
                  onChange={(e) => {
                    set_parallel_body_distance(e.target.value);
                    clearError("parallel_body_distance");
                  }}
                />
                {errors?.parallel_body_distance && (
                  <span style={{ color: "red" }}>{errors?.parallel_body_distance}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Constant Weight</label>
                <Input
                  value={constant_weight}
                  placeholder="Constant Weight"
                  onChange={(e) => {
                    set_constant_weight(e.target.value);
                    clearError("constant_weight");
                  }}
                />
                {errors?.constant_weight && (
                  <span style={{ color: "red" }}>{errors?.constant_weight}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Maximum Height Above Water Line</label>
                <Input
                  value={max_height_above_waterline}
                  placeholder="Maximum Height Above Water Line"
                  onChange={(e) => {
                    set_max_height_above_waterline(e.target.value);
                    clearError("max_height_above_waterline");
                  }}
                />
                {errors?.max_height_above_waterline && (
                  <span style={{ color: "red" }}>{errors?.max_height_above_waterline}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-6">
              <div className="input-box">
                <label>Does Vessel have Full Mast/Collapsed Mast</label>
                <br />

                <Select
                  name="full mast"
                  onChange={handleSelectChange}
                  value={full_mast}
                  style={{ width: "100%" }}
                >
                  <Option value={0}>Collapsed Mast</Option>
                  <Option value={1}>Full Mast</Option>
                </Select>

                {errors?.full_mast && <span style={{ color: "red" }}>{errors?.full_mast}</span>}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Lightship</label>
                <Input
                  value={lightship}
                  placeholder="Lightship"
                  onChange={(e) => {
                    set_lightship(e.target.value);
                    clearError("lightship");
                  }}
                />
                {errors?.lightship && <span style={{ color: "red" }}>{errors?.lightship}</span>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Normal Ballast</label>
                <Input
                  value={normal_ballast}
                  placeholder="Normal Ballast"
                  onChange={(e) => {
                    set_normal_ballast(e.target.value);
                    clearError("normal_ballast");
                  }}
                />
                {errors?.normal_ballast && (
                  <span style={{ color: "red" }}>{errors?.normal_ballast}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>At Loaded Summer deadweight</label>
                <Input
                  value={loaded_summer_deadweight}
                  placeholder="Loaded Summer deadweight"
                  onChange={(e) => {
                    set_loaded_summer_deadweight(e.target.value);
                    clearError("loaded_summer_deadweight");
                  }}
                />
                {errors?.loaded_summer_deadweight && (
                  <span style={{ color: "red" }}>{errors?.loaded_summer_deadweight}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Gross Tonnage<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={gross_tonnage}
                  placeholder="Gross Tonnage"
                  onChange={(e) => {
                    set_gross_tonnage(e.target.value);
                    clearError("gross_tonnage");
                  }}
                />
                {errors?.gross_tonnage && (
                  <span style={{ color: "red" }}>{errors?.gross_tonnage}</span>
                )}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Suez Canal Tonnage</label>
                <Input
                  value={suez_canal_tonnage}
                  placeholder="Suez Canal Tonnage"
                  onChange={(e) => {
                    set_suez_canal_tonnage(e.target.value);
                    clearError("suez_canal_tonnage");
                  }}
                />
                {errors?.suez_canal_tonnage && (
                  <span style={{ color: "red" }}>{errors?.suez_canal_tonnage}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Tonnage</label>
                <Input
                  value={net_tonnage}
                  placeholder="Tonnage"
                  onChange={(e) => {
                    set_net_tonnage(e.target.value);
                    clearError("net_tonnage");
                  }}
                />
                {errors?.net_tonnage && <span style={{ color: "red" }}>{errors?.net_tonnage}</span>}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>Panama Canal Tonnage</label>
                <Input
                  value={panama_canal_tonnage}
                  placeholder="panama canal tonnage"
                  onChange={(e) => {
                    set_panama_canal_tonnage(e.target.value);
                    clearError("panama_canal_tonnage");
                  }}
                />
                {errors?.panama_canal_tonnage && (
                  <span style={{ color: "red" }}>{errors?.panama_canal_tonnage}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>Extreme Breadth</label>
                <Input
                  value={extreme_breadth}
                  placeholder="Extreme breadth"
                  onChange={(e) => {
                    set_extreme_breadth(e.target.value);
                    clearError("extreme_breadth");
                  }}
                />
                {errors?.extreme_breadth && (
                  <span style={{ color: "red" }}>{errors?.extreme_breadth}</span>
                )}
              </div>
            </div>

            <div className="col-6">
              <div className="input-box">
                <label>Access IP</label>
                <Input
                  value={access_ip}
                  placeholder="Access IP"
                  onChange={(e) => {
                    set_access_ip(e.target.value);
                    clearError("access_ip");
                  }}
                />
                {errors?.access_ip && <span style={{ color: "red" }}>{errors?.access_ip}</span>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  Call Sign<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  maxLength={6}
                  value={call_sign}
                  placeholder="call sign"
                  onChange={(e) => {
                    set_call_sign(e.target.value);
                    clearError("call_sign");
                  }}
                />
                {errors?.call_sign && <span style={{ color: "red" }}>{errors?.call_sign}</span>}
              </div>
            </div>
            <div className="col-6">
              <div className="input-box">
                <label>
                  Telephone<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={telephone}
                  maxLength={15}
                  placeholder="telephone"
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 15) {
                      set_telephone(value);
                      clearError("telephone");
                    }
                  }}
                />
                {errors?.telephone && <span style={{ color: "red" }}>{errors?.telephone}</span>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="input-box">
                <label>
                  pitch<span style={{ color: "red" }}>*</span>
                </label>
                <Input
                  value={pitch}
                  placeholder="pitch"
                  onChange={(e) => {
                    set_pitch(e.target.value);
                    clearError("pitch");
                  }}
                />
                {errors?.pitch && <span style={{ color: "red" }}>{errors?.pitch}</span>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="input-box" style={{ marginTop: "15px" }}>
        {id ? (
          <Button type="primary" onClick={UPDATE_API} loading={loader}>
            save
          </Button>
        ) : (
          <Button type="primary" onClick={ADD_API} loading={loader}>
            save
          </Button>
        )}
      </div>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
            maxWidth: "900px",
            maxHeight: "400px",
            objectFit: "contain",
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
}

export default Ships;
